import React, { useState, useContext } from 'react';
import { createPortal } from "react-dom";
import './PDFViewerInternal.scss';
import Spinner from "../Spinner";
import Container from "../Container";
import PDFViewerLite from "./PDFViewerLite";
import Context from "../../../context";

const PDFViewerInternal = ({ pdfUrl, onClose, closePath }) => {
  const { viewMode, isSafari } = useContext(Context);

  const [loading, setLoading] = useState(true);

  const renderIframe = () => (
    <iframe
      title="Doc Viewer"
      src={pdfUrl}
      width="100%"
      height="100%"
      style={{
        overflow: 'scroll',
        display: loading ? 'none' : 'block',
        border: 'none',
      }}
      onLoad={() => setLoading(false)}
    ></iframe>
  );

  return createPortal(
    <div className="pdf-viewer-overlay">
      <Container
        className="container-ewa-pdf"
        mainElementClassName={`ewa-pdf ewa-pdf-${viewMode}`}
        barebonesMode
        isDocViewer
        closeButtonClickFn={onClose}
        backButtonClickFn={onClose}
        closePath={closePath}
      >
        {loading && (
          <div className="pdf-viewer-spinner">
            <Spinner type="small" />
          </div>
        )}
        <div className="pdf-viewer-wrapper">
          {(viewMode === 'mobile' || isSafari)
            ? <PDFViewerLite fileUrl={pdfUrl} loading={loading} setLoading={setLoading} />
            : renderIframe()}
        </div>
      </Container>
    </div>,
    document.body
  );
};

export default PDFViewerInternal;